import { ListItem, withStyles } from "@material-ui/core";

export const CourseItemListItem = withStyles({ root: { backgroundColor: "white" } })(ListItem);
